import { BrowserRouter, Navigate, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { ScenarioListPage } from "./pages/ScenarioListPage";
import { ConversationPage } from "./pages/ConversationPage";
import { FeedbackPage } from "./pages/FeedbackPage";
import { ListenOnlyPage } from "./pages/ListenOnlyPage";

function ConversationRoute() {
  const { scenarioId } = useParams<{ scenarioId: string }>();
  const navigate = useNavigate();
  if (!scenarioId) return <Navigate to="/" replace />;
  return (
    <ConversationPage
      scenarioId={scenarioId}
      onFinished={(result) =>
        navigate("/feedback", { state: result, replace: true })
      }
    />
  );
}

function ListenOnlyRoute() {
  const { scenarioId } = useParams<{ scenarioId: string }>();
  if (!scenarioId) return <Navigate to="/" replace />;
  return <ListenOnlyPage scenarioId={scenarioId} />;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ScenarioListPage />} />
        <Route path="/talk/:scenarioId" element={<ConversationRoute />} />
        <Route path="/listen/:scenarioId" element={<ListenOnlyRoute />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
